import {
  getChannelName,
  getCategory,
  getCategoryByGlobal,
  getVideoContent,
  getVideoDesc,
  getVideoTag,
  getVideoTitle,
  getChannelNameByGlobal,
  getVideoTagByGlobal,
} from './language';

export const DBOM_CONTENT = {
  videoTitle: getVideoTitle,
  videoContent: getVideoContent,
  category: getCategory,
  categoryGlobal: getCategoryByGlobal, 
  channelName: getChannelName,
  channelNameGlobal: getChannelNameByGlobal,
  videoTag: getVideoTag,
  videoTagGlobal: getVideoTagByGlobal,
  videoDesc: getVideoDesc,
};

export * from './gameMap';
